// extracted by mini-css-extract-plugin
module.exports = {"item":"FeatureList_item__43JP9","icon":"FeatureList_icon__hZ_lr","contentNotAvailable":"FeatureList_contentNotAvailable__rFf3W"};